export const formatTime = (timeString) => {
        if (!timeString) return '';
        
        // Remove seconds and split into hours and minutes
        const [hours, minutes] = timeString.split(':').slice(0, 2);
        const hour24 = parseInt(hours, 10);
        const hour12 = hour24 === 0 ? 12 : hour24 > 12 ? hour24 - 12 : hour24;
        const ampm = hour24 >= 12 ? 'PM' : 'AM';
        
        return `${hour12}:${minutes} ${ampm}`;
    };